import { Alert, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { snackBarStorageID } from '../../../constants';
import {
	addLocalStorageEventListener,
	getLocalStorageItem,
} from '../../../functions/local-storage';
import IconSelector from '../../util-components/icon-loader/icon-selector';
import ButtonWrapper from '../button-wrapper/button-wrapper';
import SnackBarPayload from './snack-bar-payload';

export default function SnackbarWrapper() {
	const [snackBarPayload, setSnackBarPayload] = useState<SnackBarPayload>({
		message: '',
	});
	const [visible, setVisible] = useState<boolean>(false);

	useEffect(() => {
		addLocalStorageEventListener(snackBarStorageID, () => {
			const localData = getLocalStorageItem(snackBarStorageID);
			setSnackBarPayload(JSON.parse(localData));
			setVisible(true);
		});
	}, []);

	const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}

		const temp = { ...snackBarPayload };
		setVisible(false);
		window.sessionStorage.removeItem(snackBarStorageID);
		setSnackBarPayload(temp);
	};

	const action = (
		<ButtonWrapper
			id="AddMapping"
			icon={IconSelector.Close}
			label="Add"
			size="small"
			onClick={e => {
				handleClose(e);
			}}
		/>
	);

	const authHideDuration = () => {
		switch (snackBarPayload.severity) {
			case 'error':
			case 'warning':
				return 5000;
			default:
				return 2000;
		}
	};

	return (
		<Snackbar
			open={visible}
			autoHideDuration={authHideDuration()}
			onClose={handleClose}
			action={action}
			sx={{ zIndex: 1500 }}
		>
			<Alert
				onClose={handleClose}
				severity={snackBarPayload.severity ?? 'info'}
				sx={{ width: '100%' }}
			>
				{snackBarPayload.message}
			</Alert>
		</Snackbar>
	);
}
